@if (loadingService.isLoading()) {
  <div class="hx-global-loader-backdrop" role="presentation">
    <!-- Outer glow ring: 30% of viewport, radial gradient transparent outward -->
    <div class="hx-global-loader-glow-outer" aria-hidden="true"></div>
    <!-- Inner white circle: larger than the logo, radial gradient transparent outward -->
    <div class="hx-global-loader-glow-inner" aria-hidden="true"></div>
    <div class="hx-global-loader-content">
      <hx-loader
        animation="spiral"
        size="xlarge"
        speed="normal"
        [overlay]="false"
        ariaLive="polite"
        ariaLabel="Loading, please wait" />
      @if (primaryMessage()) {
        <div class="hx-global-loader-message-container" role="status" aria-live="polite">
          <p class="hx-global-loader-message">
            <span>{{ primaryMessage() }}</span>
            @if (additionalCount() > 0) {
              <span class="hx-global-loader-more-badge" tabindex="0" aria-label="View all active background calls">
                (+{{ additionalCount() }} more)
                <div class="hx-global-loader-popover" role="tooltip">
                  <div class="hx-global-loader-popover-header">
                    <span>Active Calls</span>
                    <span class="hx-global-loader-popover-count">{{ activeCallsList().length }}</span>
                  </div>
                  <ul class="hx-global-loader-popover-list">
                    @for (callMsg of activeCallsList(); track $index) {
                      <li class="hx-global-loader-popover-item">
                        <span class="hx-global-loader-popover-num">{{ $index + 1 }}.</span>
                        <span class="hx-global-loader-popover-text">{{ callMsg }}</span>
                      </li>
                    }
                  </ul>
                </div>
              </span>
            }
          </p>
        </div>
      }
    </div>
  </div>
}
